import styled from "styled-components";
import { Checkbox } from "antd";
import { theme } from "../../../config";

export const CheckboxStyled = styled(Checkbox)`
  &:hover {
    // color: ${theme.colors.secondary}
  }
`